import { selector } from 'recoil';
import { determineOrderStatus } from '../../helpers/order-status.js';
import shoppingCartState from './shopping-cart-state.js';
const shoppingCartStatusState = selector({
    key: 'shoppingCartStatus',
    get: ({ get }) => {
        const shoppingCart = get(shoppingCartState.response);
        if (shoppingCart && shoppingCart.AdditionalOrderData?.RequiredData) {
            return determineOrderStatus({
                order: shoppingCart.ShoppingCart,
                requiredData: shoppingCart.AdditionalOrderData?.RequiredData,
                productRequirements: shoppingCart.AdditionalOrderData?.ProductRequirements ?? undefined,
            });
        }
    },
});
export default shoppingCartStatusState;
//# sourceMappingURL=shopping-cart-status-state.js.map